import React from "react";
import { X } from "lucide-react";
import BulkEnquiryForm from "./BulkEnquiryForm";

export default function BulkEnquiryDialog({ open, initialGrade, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center px-4 py-8" data-testid="enquiry-dialog">
      <div className="absolute inset-0 bg-[#2D004F]/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-[#FCFAF8] w-full max-w-2xl rounded-2xl border border-[#E5E0D8] shadow-2xl max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="sticky top-4 ml-auto mr-4 mt-4 h-10 w-10 rounded-full bg-white border border-[#E5E0D8] flex items-center justify-center hover:bg-[#F3EFEA] z-10"
          aria-label="Close"
          data-testid="enquiry-dialog-close"
        >
          <X size={18} />
        </button>
        <div className="px-8 md:px-10 pb-8 md:pb-10 -mt-4">
          <div className="eyebrow mb-3">Bulk Wholesale</div>
          <h3 className="font-display text-3xl md:text-4xl text-[#4B0082] mb-2">Get your bulk Ube Powder quote</h3>
          <p className="text-[#666] mb-8">Fill in the form below — our team will revert within 24 hours with pricing and samples.</p>
          <BulkEnquiryForm onSuccess={onClose} initialGrade={initialGrade} />
        </div>
      </div>
    </div>
  );
}
